import api from '@src/utils/api';
import addDays from 'date-fns/addDays';
import { action, makeObservable, observable, reaction } from 'mobx';

class CalendarRepository {
  selectedWeek = new Date().toISOString().split('T')[0];
  selectedTeacherId = null;
  calendarData = [];
  isLoading = null;

  constructor() {
    makeObservable(this, {
      selectedWeek: observable,
      calendarData: observable,
      isLoading: observable,
      updateCalendarData: action,
      updateSelectedWeek: action,
      updateLoading: action,
    });
  }

  async initCalendar(callback, id) {
    reaction(
      () => this.isLoading,
      () =>
        callback({
          selectedWeek: this.selectedWeek,
          calendarData: this.calendarData,
          isLoading: this.isLoading,
        }),
      { fireImmediately: true }
    );
    this.selectedTeacherId = id;
    await this.loadCalendarData(this.selectedTeacherId, this.selectedWeek);
  }

  async loadCalendarData(id, date) {
    this.updateLoading(true);
    const response = await api.get(`teachers/${id}/calendor/${date}`);
    this.updateCalendarData(response);
    this.updateLoading(false);
  }

  async getNextWeekData() {
    const nextDate = addDays(new Date(this.selectedWeek), 7)
      .toISOString()
      .split('T')[0];
    this.updateSelectedWeek(nextDate);

    await this.loadCalendarData(this.selectedTeacherId, this.selectedWeek);
  }

  async getPrevWeekData() {
    const prevDate = addDays(new Date(this.selectedWeek), -7)
      .toISOString()
      .split('T')[0];
    this.updateSelectedWeek(prevDate);

    await this.loadCalendarData(this.selectedTeacherId, this.selectedWeek);
  }

  updateCalendarData(data) {
    this.calendarData = data;
  }
  resetSelectedWeek() {
    this.selectedWeek = new Date().toISOString().split('T')[0];
  }
  updateSelectedWeek(newDate) {
    this.selectedWeek = newDate;
  }

  updateLoading(state) {
    this.isLoading = state;
  }
}

const calendarRepository = new CalendarRepository();

export default calendarRepository;
